import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { DEFAULT_LAYOUT, REUSABLE_COMPONENT_NODE_TYPE } from './contract';
import { ReusableComponentView } from './ReusableComponentView';

// A SINGLE wrapper node for every reusable component; the concrete component id
// lives in attrs.component and the registry fans out from there (one node, one
// NodeView, one runner branch). atom: a leaf with no editable inner content —
// it's configured via its settings modal, not typed into.
//
// All attrs are `rendered: false`: they persist via getJSON() (the transport)
// but are NOT serialised onto the DOM element (object attrs would become
// "[object Object]"); we never round-trip these via HTML.
export const ReusableComponent = Node.create({
  name: REUSABLE_COMPONENT_NODE_TYPE,
  group: 'block',
  atom: true,
  selectable: true, // required — drag-to-reorder creates a NodeSelection
  // Drag-to-reorder within the editor. ProseMirror sets draggable on the node
  // DOM; the actual grab is gated to the [data-drag-handle] grip in the NodeView
  // (TipTap v3, PR #3677), so the body/buttons/resize-handle don't start a drag.
  draggable: true,

  addAttributes() {
    return {
      component: { default: '', rendered: false },
      version: { default: 1, rendered: false },
      config: { default: {}, rendered: false },
      data: { default: null, rendered: false },
      sourceId: { default: null, rendered: false },
      layout: { default: { ...DEFAULT_LAYOUT }, rendered: false },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="reusable-component"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    // atom leaf → no content hole (no trailing 0).
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'reusable-component' })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ReusableComponentView);
  },
});
